export type Language = 'de' | 'en';

export const translations = {
  // ===== LANDING PAGE =====
  landing: {
    navStart: { de: 'Start Training', en: 'Start Training' },
    badge: { de: 'Dart Training App', en: 'Dart Training App' },
    heroTitle1: { de: 'Train smarter.', en: 'Train smarter.' },
    heroTitle2: { de: 'Hit better.', en: 'Hit better.' },
    heroTitle3: { de: 'Level up', en: 'Level up' },
    heroTitle4: { de: 'your darts.', en: 'your darts.' },
    heroDesc: {
      de: 'AimUp ist deine persönliche Dart-Trainings-App mit Tracking, Statistiken und strukturierten Trainingsplänen für jedes Level – vom Anfänger bis zum Profi.',
      en: 'AimUp is your personal dart training app with tracking, statistics and structured training plans for every level – from beginner to pro.',
    },
    statModes: { de: 'Trainingsmodi', en: 'Training modes' },
    statLevels: { de: 'Schwierigkeitsstufen', en: 'Difficulty levels' },
    statSessions: { de: 'Sessions', en: 'Sessions' },
    dashboard: { de: 'Dashboard', en: 'Dashboard' },
    performance: { de: 'Performance', en: 'Performance' },
    hitRate: { de: 'Trefferquote', en: 'Hit rate' },
    average: { de: 'Average', en: 'Average' },
    sessions: { de: 'Sessions', en: 'Sessions' },
    featuresLabel: { de: 'Features', en: 'Features' },
    featuresTitle1: { de: 'Alles was du brauchst,', en: 'Everything you need,' },
    featuresTitle2: { de: 'um besser zu werden', en: 'to get better' },
    featurePreciseTitle: { de: 'Präzises Tracking', en: 'Precise Tracking' },
    featurePreciseDesc: { de: 'Verfolge jeden Dart und analysiere deine Trefferquote in Echtzeit.', en: 'Track every dart and analyze your hit rate in real time.' },
    featureStatsTitle: { de: 'Detaillierte Statistiken', en: 'Detailed Statistics' },
    featureStatsDesc: { de: 'Single-, Triple- und Doppelquoten, Average, Checkouts und Fortschritt.', en: 'Single, triple and double rates, average, checkouts and progress.' },
    featurePlansTitle: { de: 'Strukturierte Trainingspläne', en: 'Structured Training Plans' },
    featurePlansDesc: { de: 'Geführte Sessions für Newbies, Anfänger, Fortgeschrittene und Profis.', en: 'Guided sessions for newbies, beginners, intermediate and pro players.' },
    featureLevelTitle: { de: 'Level & Challenges', en: 'Levels & Challenges' },
    featureLevelDesc: { de: 'Sammle XP, schalte Level frei und messe dich mit anderen Spielern.', en: 'Earn XP, unlock levels and compete with other players.' },
    trainingSystem: { de: 'Training System', en: 'Training System' },
    trainingTitle1: { de: 'Dein Weg vom', en: 'Your path from' },
    trainingTitle2: { de: 'Newbie zum', en: 'Newbie to' },
    trainingTitle3: { de: 'Profi', en: 'Pro' },
    levelNewbie: { de: 'Newbie', en: 'Newbie' },
    levelNewbieDesc: { de: 'Lerne Technik, Haltung und Kontrolle.', en: 'Learn technique, stance and control.' },
    levelBeginner: { de: 'Anfänger', en: 'Beginner' },
    levelBeginnerDesc: { de: 'Verbessere Präzision und sichere Doppel.', en: 'Improve precision and secure doubles.' },
    levelAdvanced: { de: 'Fortgeschritten', en: 'Advanced' },
    levelAdvancedDesc: { de: 'Scoring, Checkouts und Matchsimulation.', en: 'Scoring, checkouts and match simulation.' },
    levelPro: { de: 'Profi', en: 'Pro' },
    levelProDesc: { de: 'Konstanz, Drucktraining und Wettkampfmodus.', en: 'Consistency, pressure training and competition mode.' },
    level: { de: 'Level', en: 'Level' },
    startPlan: { de: 'Trainingsplan starten', en: 'Start Training Plan' },
    footer: { de: 'Alle Rechte vorbehalten.', en: 'All rights reserved.' },
  },

  // ===== AUTH =====
  auth: {
    welcomeBack: { de: 'Willkommen zurück', en: 'Welcome back' },
    trialNoticeTitle: { de: 'Deine Testphase läuft', en: 'Your trial has started' },
    trialNoticeText: {
      de: '14 Tage voller Zugriff auf dein Persönliches Training, die AimUp Liga und die lokalen Spiele – kostenlos und ohne Zahlungsdaten. Deine Testphase endet am {date}.',
      en: '14 days of full access to your Personal Training, the AimUp League and the local games – free of charge and without payment details. Your trial ends on {date}.',
    },
    trialDialogTitle: { de: 'Willkommen bei AimUp', en: 'Welcome to AimUp' },
    trialDialogText: {
      de: 'Deine Testphase läuft noch bis zum {date}. Bis dahin hast du vollen Zugriff auf dein Persönliches Training, die AimUp Liga und die lokalen Spiele – kostenlos und ohne Zahlungsdaten.',
      en: 'Your trial runs until {date}. Until then you have full access to your Personal Training, the AimUp League and the local games – free of charge and without payment details.',
    },
    trialDialogCta: { de: "Los geht's", en: "Let's go" },
    trialDialogProLink: { de: 'Alles zu AimUp Pro', en: 'More about AimUp Pro' },
    joinAimUp: { de: 'Werde Teil von AimUp', en: 'Join AimUp' },
    resetPassword: { de: 'Passwort zurücksetzen', en: 'Reset password' },
    startTraining: { de: 'Training starten', en: 'Start training' },
    startTrainingSub: { de: 'Starte dein heutiges Training', en: 'Start your training today' },
    createAccountSub: { de: 'Erstelle deinen Account und leg los', en: 'Create your account and get started' },
    resetSub: { de: 'Wir senden dir einen Link zum Zurücksetzen', en: "We'll send you a link to reset it" },
    createAccount: { de: 'Account erstellen', en: 'Create account' },
    sendLink: { de: 'Link senden', en: 'Send link' },
    playerName: { de: 'Benutzername', en: 'Username' },
    yourPlayerName: { de: 'Dein Benutzername', en: 'Your username' },
    email: { de: 'E-Mail', en: 'Email' },
    password: { de: 'Passwort', en: 'Password' },
    forgotPassword: { de: 'Passwort vergessen?', en: 'Forgot password?' },
    or: { de: 'oder', en: 'or' },
    continueGoogle: { de: 'Weiter mit Google', en: 'Continue with Google' },
    noAccount: { de: 'Noch kein Konto?', en: "Don't have an account?" },
    alreadyRegistered: { de: 'Bereits registriert?', en: 'Already registered?' },
    signIn: { de: 'Anmelden', en: 'Sign in' },
    checkInbox: { de: 'Überprüfe dein Postfach', en: 'Check your inbox' },
    emailSentTo: { de: 'Wir haben dir eine E-Mail an', en: 'We sent an email to' },
    emailSentTo2: { de: 'geschickt.', en: '.' },
    clickLink: { de: 'Klicke auf den Link darin, um deinen Account zu bestätigen.', en: 'Click the link inside to confirm your account.' },
    noEmail: { de: 'Keine E-Mail bekommen? Schau auch in deinem Spam-Ordner nach.', en: "Didn't receive an email? Check your spam folder." },
    backToLogin: { de: 'Zurück zur Anmeldung', en: 'Back to login' },
    loginFailed: { de: 'Anmeldung fehlgeschlagen', en: 'Login failed' },
    wrongCredentials: { de: 'E-Mail oder Passwort falsch', en: 'Email or password incorrect' },
    confirmEmail: { de: 'Bitte bestätige zuerst deine E-Mail-Adresse', en: 'Please confirm your email address first' },
    tooManyAttempts: { de: 'Zu viele Versuche – bitte kurz warten oder Passwort zurücksetzen.', en: 'Too many attempts – please wait a moment or reset your password.' },
    resetPasswordNow: { de: 'Passwort jetzt zurücksetzen', en: 'Reset password now' },
    welcomeBackToast: { de: 'Willkommen zurück!', en: 'Welcome back!' },
    loginSuccess: { de: 'Du wurdest erfolgreich angemeldet.', en: 'You have been successfully signed in.' },
    error: { de: 'Fehler', en: 'Error' },
    enterPlayerName: { de: 'Bitte gib einen Benutzernamen ein.', en: 'Please enter a username.' },
    usernameTaken: { de: 'Dieser Benutzername ist bereits vergeben.', en: 'This username is already taken.' },
    usernameAvailable: { de: 'verfügbar', en: 'available' },
    usernameTakenShort: { de: 'vergeben', en: 'taken' },
    usernameChecking: { de: 'prüfe …', en: 'checking…' },
    registerFailed: { de: 'Registrierung fehlgeschlagen', en: 'Registration failed' },
    confirmEmailSent: { de: 'Bestätigungs-E-Mail gesendet!', en: 'Confirmation email sent!' },
    checkInboxDesc: { de: 'Bitte überprüfe dein Postfach und bestätige deine E-Mail-Adresse.', en: 'Please check your inbox and confirm your email address.' },
    emailSent: { de: 'E-Mail gesendet!', en: 'Email sent!' },
    checkResetLink: { de: 'Überprüfe dein Postfach für den Link zum Zurücksetzen.', en: 'Check your inbox for the reset link.' },
    googleFailed: { de: 'Google-Anmeldung fehlgeschlagen', en: 'Google sign-in failed' },
    googleError: { de: 'Google-Anmeldung konnte nicht gestartet werden.', en: 'Could not start Google sign-in.' },
    eyebrowLogin: { de: 'Anmelden', en: 'Sign in' },
    eyebrowRegister: { de: 'Registrieren', en: 'Sign up' },
    eyebrowForgot: { de: 'Passwort vergessen', en: 'Forgot password' },
    eyebrowAlmost: { de: 'Fast geschafft', en: 'Almost there' },
    homeLink: { de: 'Startseite', en: 'Home' },
    yourEmail: { de: 'deine@email.de', en: 'your@email.com' },
    showPassword: { de: 'Passwort anzeigen', en: 'Show password' },
    hidePassword: { de: 'Passwort verbergen', en: 'Hide password' },
    pwStrengthWeak: { de: 'Schwach', en: 'Weak' },
    pwStrengthMedium: { de: 'Mittel', en: 'Medium' },
    pwStrengthGood: { de: 'Gut', en: 'Good' },
    pwStrengthStrong: { de: 'Stark', en: 'Strong' },
    pwReq8: { de: 'Mindestens 10 Zeichen', en: 'At least 10 characters' },
    pwReqUpper: { de: 'Ein Großbuchstabe', en: 'One uppercase letter' },
    pwReqNumber: { de: 'Eine Zahl', en: 'One number' },
    pwReqSpecial: { de: 'Ein Sonderzeichen (z. B. ! ? # - _ .)', en: 'One special character (e.g. ! ? # - _ .)' },
    termsAcceptPrefix: { de: 'Ich akzeptiere die', en: 'I accept the' },
    termsAcceptAgb: { de: 'AGB', en: 'Terms and Conditions' },
    termsAcceptAnd: { de: 'und habe die', en: 'and have read the' },
    termsAcceptPrivacy: { de: 'Datenschutzerklärung', en: 'Privacy Policy' },
    termsAcceptSuffix: {
      de: ' zur Kenntnis genommen.',
      en: '.',
    },
    ageConfirmLabel: {
      de: 'Ich bin mindestens 14 Jahre alt oder nutze AimUp mit Zustimmung meiner Erziehungsberechtigten.',
      en: 'I am at least 14 years old or use AimUp with the consent of my legal guardian.',
    },
  },


  // ===== INDEX / DASHBOARD =====
  index: {
    loading: { de: 'Laden...', en: 'Loading...' },
    player: { de: 'Spieler', en: 'Player' },
    yourDartTraining: { de: 'Dein persönliches Dart Training', en: 'Your personal dart training' },
    yourProgress: { de: 'Dein Fortschritt', en: 'Your Progress' },
    training: { de: 'Training', en: 'Training' },
    sessions: { de: 'Sessions', en: 'Sessions' },
    hitRate: { de: 'Trefferquote', en: 'Hit rate' },
    record: { de: 'Rekord', en: 'Record' },
    liga: { de: 'Liga', en: 'League' },
    beginner: { de: 'Anfänger', en: 'Beginner' },
    xp: { de: 'XP', en: 'XP' },
    aimUpLiga: { de: 'AimUp Liga', en: 'AimUp League' },
    aimUpLigaDesc: { de: 'Stell dein Können in verschiedenen Ligen auf die Probe.', en: 'Test your skills across different leagues.' },
    open: { de: 'Öffnen', en: 'Open' },
    personalTraining: { de: 'Persönliches Training', en: 'Personal Training' },
    personalTrainingDesc: { de: 'Trainiere deine Technik und verbessere deine Trefferquote.', en: 'Train your technique and improve your hit rate.' },
    progress: { de: 'Fortschritt', en: 'Progress' },
    friends: { de: 'Freunde', en: 'Friends' },
    friendsDesc: { de: 'Vergleiche dich mit deinen Freunden und fordere sie heraus.', en: 'Compare yourself with your friends and challenge them.' },
    friendsOnline: { de: 'Freunde online:', en: 'Friends online:' },
  },

  // ===== PROFILE =====
  profile: {
    myProfile: { de: 'Mein Profil', en: 'My Profile' },
    startPage: { de: 'Startseite', en: 'Home' },
    backToHome: { de: 'Startseite', en: 'Home' },
    tabProfile: { de: 'Profileinstellungen', en: 'Profile settings' },
    tabSubscription: { de: 'Abo Verwalten', en: 'Manage subscription' },
    pageTitle: { de: 'Profil-Einstellungen', en: 'Profile settings' },
    sectionPersonal: { de: 'Persönliche Informationen', en: 'Personal information' },
    sectionAccount: { de: 'Konto-Info', en: 'Account info' },
    edit: { de: 'Bearbeiten', en: 'Edit' },
    cancelEdit: { de: 'Abbrechen', en: 'Cancel' },
    uploadNewPic: { de: 'Neues Bild hochladen', en: 'Upload new picture' },
    deletePic: { de: 'Bild löschen', en: 'Delete picture' },
    clickToChange: { de: 'Klicke zum Ändern des Profilbilds', en: 'Click to change profile picture' },
    username: { de: 'Benutzername', en: 'Username' },
    yourUsername: { de: 'Dein Benutzername', en: 'Your username' },
    usernameFindable: { de: 'Über diesen Namen können dich andere Spieler finden.', en: 'Other players can find you by this name.' },
    usernameAvailable: { de: 'verfügbar', en: 'available' },
    usernameTaken: { de: 'vergeben', en: 'taken' },
    usernameTakenLong: { de: 'Dieser Benutzername ist bereits vergeben.', en: 'This username is already taken.' },
    realName: { de: 'Name', en: 'Name' },
    yourRealName: { de: 'Dein echter Name', en: 'Your real name' },
    country: { de: 'Land', en: 'Country' },
    selectCountry: { de: 'Wähle dein Land', en: 'Select your country' },
    birthDate: { de: 'Geburtstag', en: 'Date of birth' },
    clearDate: { de: 'Datum leeren', en: 'Clear date' },
    playerId: { de: 'Spieler-ID', en: 'Player ID' },
    throwingHand: { de: 'Wurfhand', en: 'Throwing hand' },
    handNone: { de: 'Keine Angabe', en: 'Not specified' },
    handRight: { de: 'Rechtshänder', en: 'Right-handed' },
    handLeft: { de: 'Linkshänder', en: 'Left-handed' },
    throwingHandHint: { de: 'Nur für die Trainer-Hinweise. Ohne Angabe bleibt der Hinweis allgemein.', en: 'Only used for the coach hints. Without it the hint stays general.' },
    saving: { de: 'Speichern…', en: 'Saving…' },
    saveChanges: { de: 'Änderungen speichern', en: 'Save changes' },
    noChanges: { de: 'Keine Änderungen', en: 'No changes' },
    unsavedTitle: { de: 'Ungespeicherte Änderungen', en: 'Unsaved changes' },
    unsavedDesc: { de: 'Du hast Änderungen, die noch nicht gespeichert sind. Möchtest du sie verwerfen?', en: 'You have unsaved changes. Do you want to discard them?' },
    discard: { de: 'Verwerfen', en: 'Discard' },
    stay: { de: 'Bleiben', en: 'Stay' },
    email: { de: 'E-Mail', en: 'Email' },
    newEmail: { de: 'Neue E-Mail-Adresse', en: 'New email address' },
    sendConfirmation: { de: 'Bestätigung senden', en: 'Send confirmation' },
    emailConfirmSent: { de: 'Bestätigungs-Mail an die neue Adresse gesendet – bitte Link bestätigen.', en: 'Confirmation email sent to the new address – please confirm the link.' },
    newsletter: { de: 'Newsletter', en: 'Newsletter' },
    newsletterOn: { de: 'aktiviert', en: 'enabled' },
    newsletterOff: { de: 'deaktiviert', en: 'disabled' },
    password: { de: 'Passwort', en: 'Password' },
    changePassword: { de: 'Passwort ändern', en: 'Change password' },
    currentPassword: { de: 'Aktuelles Passwort', en: 'Current password' },
    yourCurrentPassword: { de: 'Dein aktuelles Passwort', en: 'Your current password' },
    newPassword: { de: 'Neues Passwort', en: 'New password' },
    confirmPassword: { de: 'Passwort bestätigen', en: 'Confirm password' },
    repeatPassword: { de: 'Passwort wiederholen', en: 'Repeat password' },
    changing: { de: 'Ändern…', en: 'Changing…' },
    pwReqsTitle: { de: 'Anforderungen', en: 'Requirements' },
    pwReq8: { de: 'Mindestens 10 Zeichen', en: 'At least 10 characters' },
    pwReqUpper: { de: 'Großbuchstabe', en: 'Uppercase letter' },
    pwReqLower: { de: 'Kleinbuchstabe', en: 'Lowercase letter' },
    pwReqNumber: { de: 'Zahl', en: 'Number' },
    pwReqSpecial: { de: 'Sonderzeichen (z. B. ! ? # - _ .)', en: 'Special character (e.g. ! ? # - _ .)' },
    pwTooWeak: { de: 'Das Passwort erfüllt nicht alle Anforderungen.', en: 'Password does not meet all requirements.' },
    dangerZone: { de: 'Konto löschen', en: 'Delete account' },
    deleteAccountDesc: { de: 'Dein Konto und alle Trainingsdaten werden unwiderruflich gelöscht.', en: 'Your account and all training data will be permanently deleted.' },
    deleteAccount: { de: 'Konto löschen', en: 'Delete account' },
    deleteConfirmTitle: { de: 'Konto wirklich löschen?', en: 'Really delete account?' },
    deleteConfirmDesc: { de: 'Diese Aktion kann nicht rückgängig gemacht werden. Tippe zur Bestätigung deinen Benutzernamen ein.', en: 'This action cannot be undone. Type your username to confirm.' },
    deleteTypeNamePlaceholder: { de: 'Benutzername eingeben', en: 'Type username' },
    cancel: { de: 'Abbrechen', en: 'Cancel' },
    deletePermanently: { de: 'Endgültig löschen', en: 'Delete permanently' },
    error: { de: 'Fehler', en: 'Error' },
    success: { de: 'Erfolg', en: 'Success' },
    selectImage: { de: 'Bitte wähle ein Bild aus.', en: 'Please select an image.' },
    imageTooLarge: { de: 'Das Bild darf maximal 5MB groß sein.', en: 'Image must be 5MB or less.' },
    avatarUploaded: { de: 'Profilbild wurde hochgeladen.', en: 'Profile picture uploaded.' },
    avatarDeleted: { de: 'Profilbild entfernt.', en: 'Profile picture removed.' },
    avatarUploadFailed: { de: 'Profilbild konnte nicht hochgeladen werden.', en: 'Could not upload profile picture.' },
    profileSaved: { de: 'Profil wurde gespeichert.', en: 'Profile saved.' },
    profileSaveFailed: { de: 'Profil konnte nicht gespeichert werden.', en: 'Could not save profile.' },
    enterCurrentPassword: { de: 'Bitte gib dein aktuelles Passwort ein.', en: 'Please enter your current password.' },
    passwordsNotMatch: { de: 'Die Passwörter stimmen nicht überein.', en: 'Passwords do not match.' },
    wrongCurrentPassword: { de: 'Das aktuelle Passwort ist falsch.', en: 'Current password is incorrect.' },
    passwordChanged: { de: 'Passwort wurde geändert.', en: 'Password changed.' },
    passwordChangeFailed: { de: 'Passwort konnte nicht geändert werden.', en: 'Could not change password.' },
    accountDeleted: { de: 'Konto gelöscht', en: 'Account deleted' },
    accountDeletedDesc: { de: 'Dein Konto und alle Daten wurden gelöscht.', en: 'Your account and all data have been deleted.' },
    accountDeleteFailed: { de: 'Konto konnte nicht gelöscht werden.', en: 'Could not delete account.' },
  },

  // ===== STATISTICS =====
  statistics: {
    title: { de: 'Statistiken', en: 'Statistics' },
    subtitle: { de: 'Deine Spielanalysen', en: 'Your game analyses' },
    startPage: { de: 'Startseite', en: 'Home' },
    noData: { de: 'Keine Daten vorhanden', en: 'No data available' },
    noDataDesc: { de: 'Absolviere dein erstes Training, um Statistiken zu sehen.', en: 'Complete your first training to see statistics.' },
    overview: { de: 'Gesamtübersicht', en: 'Overview' },
    trainings: { de: 'Trainings', en: 'Trainings' },
    avgHitRate: { de: 'Ø Trefferquote', en: 'Avg. hit rate' },
    totalThrows: { de: 'Würfe gesamt', en: 'Total throws' },
    totalHits: { de: 'Treffer gesamt', en: 'Total hits' },
    segmentAnalysis: { de: 'Segment-Analyse', en: 'Segment Analysis' },
    bestSegment: { de: 'Bestes Segment', en: 'Best segment' },
    worstSegment: { de: 'Schwächstes Segment', en: 'Weakest segment' },
    allSegments: { de: 'Alle Segmente:', en: 'All segments:' },
    history: { de: 'Trainingshistorie', en: 'Training history' },
    throws: { de: 'Würfe', en: 'Throws' },
    hits: { de: 'Treffer', en: 'Hits' },
    analysis: { de: 'Analyse:', en: 'Analysis:' },
    aroundTheClock: { de: 'Around the Clock', en: 'Around the Clock' },
    singleTarget: { de: 'Single-Treffertraining', en: 'Single Target Training' },
  },

  // ===== FRIENDS =====
  friends: {
    title: { de: 'Freunde', en: 'Friends' },
    addFriend: { de: 'Freund hinzufügen', en: 'Add friend' },
    enterUsername: { de: 'Username eingeben', en: 'Enter username' },
    add: { de: 'Hinzufügen', en: 'Add' },
    suggestions: { de: 'Vorschläge', en: 'Suggestions' },
    follow: { de: 'Folgen', en: 'Follow' },
    friendsList: { de: 'Freundesliste', en: 'Friends list' },
    noFriends: { de: 'Noch keine Freunde hinzugefügt', en: 'No friends added yet' },
    noFriendsDesc: { de: 'Füge Freunde über ihren Username hinzu!', en: 'Add friends by their username!' },
    unknown: { de: 'Unbekannt', en: 'Unknown' },
    weeklyRanking: { de: 'Wochenranking', en: 'Weekly ranking' },
    noRanking: { de: 'Noch kein Ranking verfügbar', en: 'No ranking available yet' },
    noRankingDesc: { de: 'Trainiere und füge Freunde hinzu!', en: 'Train and add friends!' },
    you: { de: '(Du)', en: '(You)' },
    sessionsThisWeek: { de: 'Sessions diese Woche', en: 'Sessions this week' },
    findById: { de: 'Spieler per ID finden', en: 'Find player by ID' },
    enterPlayerId: { de: 'Spieler-ID (z. B. #1042)', en: 'Player ID (e.g. #1042)' },
    search: { de: 'Suchen', en: 'Search' },
    noPlayerWithId: { de: 'Kein Spieler mit dieser ID gefunden.', en: 'No player found with this ID.' },
    invalidPlayerId: { de: 'Bitte gib eine gültige Spieler-ID ein.', en: 'Please enter a valid Player ID.' },
    alreadyFriend: { de: 'Bereits dein Freund', en: 'Already your friend' },
    requestPending: { de: 'Anfrage läuft', en: 'Request pending' },
  },

  // ===== LIGA =====
  liga: {
    title: { de: 'AimUp Liga', en: 'AimUp League' },
    subtitle: { de: 'Wähle deine Trainingskategorie', en: 'Choose your training category' },
    dashboard: { de: 'Dashboard', en: 'Dashboard' },
    backToLiga: { de: 'Zurück zur Liga', en: 'Back to League' },
    games: { de: 'Spiele', en: 'Games' },

    // Categories
    warmUp: { de: 'Aufwärmen', en: 'Warm-up' },
    warmUpSub: { de: 'Aktiviere Technik & Gefühl', en: 'Activate technique & feeling' },
    newbie: { de: 'Newbie', en: 'Newbie' },
    newbieSub: { de: 'Grundlagen & erste Schritte', en: 'Basics & first steps' },
    bloodyRookie: { de: 'Bloody Rookie', en: 'Bloody Rookie' },
    bloodyRookieSub: { de: 'Härtere Herausforderungen', en: 'Tougher challenges' },
    beginner: { de: 'Anfänger', en: 'Beginner' },
    beginnerSub: { de: 'Technik verbessern', en: 'Improve technique' },
    advanced: { de: 'Fortgeschritten', en: 'Advanced' },
    advancedSub: { de: 'Präzision & Konsistenz', en: 'Precision & consistency' },
    semiPro: { de: 'Halbprofi', en: 'Semi-Pro' },
    semiProSub: { de: 'Auf dem Weg zur Meisterschaft', en: 'On the way to mastery' },
    pro: { de: 'Profi', en: 'Pro' },
    proSub: { de: 'Meisterschaft & Wettkampf', en: 'Mastery & competition' },
    bdc: { de: 'BDC - Best Dart Club', en: 'BDC - Best Dart Club' },
    bdcSub: { de: 'Elite Training', en: 'Elite Training' },

    // Game titles & descriptions
    warmUpRoutine: { de: 'Aufwärmroutine', en: 'Warm-up routine' },
    warmUpRoutineDesc: { de: 'Bull-Aufwärmen, Single-Kontrolle, Doppeltraining und einmal jedes Feld anwerfen. Aktiviere deine Technik ohne Leistungsdruck.', en: 'Bull warm-up, single control, double training and hit every field once. Activate your technique without pressure.' },
    aroundTheClock: { de: 'Around the Clock', en: 'Around the Clock' },
    atcNewbieDesc: { de: 'Triff jede Zahl von 1 bis Bull nacheinander. Es ist egal ob Single, Double oder Triple-Felder.', en: 'Hit every number from 1 to Bull in order. Single, double or triple fields all count.' },
    atcBloodyDesc: { de: 'Triff jede Zahl von 1 bis Bull nacheinander.', en: 'Hit every number from 1 to Bull in order.' },
    atcBeginnerDesc: { de: 'Triff jede Zahl von 1 bis Bull nacheinander. Verbessere deine Genauigkeit auf allen Feldern.', en: 'Hit every number from 1 to Bull in order. Improve your accuracy on all fields.' },
    atcAdvancedDesc: { de: 'Triff jede Zahl von 1 bis Bull mit dem ersten Pfeil. Verfehlst du, geht es 1 Feld zurück.', en: 'Hit every number from 1 to Bull with your first dart. Miss and go back 1 field.' },
    atcSemiProDesc: { de: 'Triff jede Zahl von 1 bis Bull mit dem ersten Pfeil. Verfehlst du, geht es 2 Felder zurück.', en: 'Hit every number from 1 to Bull with your first dart. Miss and go back 2 fields.' },
    atcProDesc: { de: 'Triff jede Zahl von 1 bis Bull mit dem ersten Pfeil. Verfehlst du, geht es 3 Felder zurück.', en: 'Hit every number from 1 to Bull with your first dart. Miss and go back 3 fields.' },
    atcBdcDesc: { de: 'Triff jede Zahl mit 3 Pfeilen, von 1 bis Bull nacheinander. Treffen nicht alle Pfeile die Zahl – geht es 1 Feld zurück.', en: 'Hit every number with 3 darts, from 1 to Bull in order. If not all darts hit – go back 1 field.' },
    game301: { de: '301', en: '301' },
    game301Desc: { de: 'Klassisches 301 auf 3 Legs mit Double-Out. Trainiere dein Finish-Game und verbessere deinen Average.', en: 'Classic 301 on 3 legs with double-out. Train your finish game and improve your average.' },
    game301BloodyDesc: { de: 'Klassisches 301 mit Double-Out.', en: 'Classic 301 with double-out.' },
    segmentTraining: { de: 'Segmenttraining', en: 'Segment Training' },
    segBloodyDesc: { de: 'Trainiere gezielt die Felder 20, 19 und 18.', en: 'Train fields 20, 19 and 18 specifically.' },
    segBeginnerDesc: { de: 'Trainiere gezielt die wichtigsten Felder: 20, 19 und 18.', en: 'Train the most important fields: 20, 19 and 18.' },
    game50: { de: 'Game 50', en: 'Game 50' },
    game50Desc: { de: 'Trainiere das Finishen!', en: 'Train your finishing!' },
    game50BeginnerDesc: { de: 'Trainiere das Finishen! Starte bei 50 und checke mit Double-Out.', en: 'Train your finishing! Start at 50 and check out with double-out.' },
    game50AdvancedDesc: { de: 'Beende 50 Punkte mit maximal 9 Pfeilen. Schaffe 5 Runden ohne Fehler!', en: 'Finish 50 points with max 9 darts. Complete 5 rounds without errors!' },
    game50SemiProDesc: { de: 'Beende 50 Punkte mit maximal 6 Pfeilen. Schaffe 5 Runden ohne Fehler!', en: 'Finish 50 points with max 6 darts. Complete 5 rounds without errors!' },
    game50ProDesc: { de: 'Beende 50 Punkte mit maximal 3 Pfeilen. Schaffe 5 Runden ohne Fehler!', en: 'Finish 50 points with max 3 darts. Complete 5 rounds without errors!' },
    game50BdcDesc: { de: 'Beende 50 Punkte mit maximal 3 Pfeilen. Schaffe 10 Runden ohne Fehler!', en: 'Finish 50 points with max 3 darts. Complete 10 rounds without errors!' },
    game501: { de: '501', en: '501' },
    game501Desc: { de: 'Klassisches 501 mit Double-Out.', en: 'Classic 501 with double-out.' },
    bullTraining: { de: 'Bull-Training', en: 'Bull Training' },
    bullDesc: { de: 'Entwickle Sicherheit auf Bull (25/50) für Checkouts und enge Ziele.', en: 'Develop confidence on Bull (25/50) for checkouts and tight targets.' },
    bullProDesc: { de: 'Entwickle Sicherheit auf Bull (25/50).', en: 'Develop confidence on Bull (25/50).' },
    bullBullseyeOnlyDesc: { de: 'Nur Bullseye zählt! Triff ausschließlich die Mitte.', en: 'Only Bullseye counts! Hit the center exclusively.' },
    perfektLeg: { de: 'Perfekt Leg', en: 'Perfect Leg' },
    perfektLegDesc: { de: 'Wirf 9 Pfeile auf die Segmente 20-20-20, 20-20-20, 20-19-12. Triff alle oder verliere!', en: 'Throw 9 darts at segments 20-20-20, 20-20-20, 20-19-12. Hit all or lose!' },
    perfektLegAdvancedDesc: { de: 'Wirf 9 Pfeile auf die Segmente 20-20-20, 20-20-20, 20-19-D12. Triff alle oder verliere!', en: 'Throw 9 darts at segments 20-20-20, 20-20-20, 20-19-D12. Hit all or lose!' },
    perfektLegSemiProDesc: { de: 'Wirf 9 Pfeile auf die Segmente 20-20-20, 20-20-20, T20-19-D12. Triff alle oder verliere!', en: 'Throw 9 darts at segments 20-20-20, 20-20-20, T20-19-D12. Hit all or lose!' },
    perfektLegProDesc: { de: 'Wirf 9 Pfeile auf die Segmente 20-20-20-20-20-T20-T20-T19-D12. Triff alle oder Verliere!', en: 'Throw 9 darts at segments 20-20-20-20-20-T20-T20-T19-D12. Hit all or lose!' },
    triple: { de: 'Triple', en: 'Triple' },
    tripleDesc: { de: 'Triff alle Triple von T20 bis T10. 9 Pfeile pro Zahl.', en: 'Hit all triples from T20 to T10. 9 darts per number.' },
    tripleProDesc: { de: 'Triff alle Triple von T20 bis T10. 6 Pfeile pro Zahl.', en: 'Hit all triples from T20 to T10. 6 darts per number.' },
    tripleBdcDesc: { de: 'Triff alle Triple von T20 bis T10. 3 Pfeile pro Zahl.', en: 'Hit all triples from T20 to T10. 3 darts per number.' },
    doppelAround: { de: 'Doppel Around', en: 'Double Around' },
    doppelAroundDesc: { de: 'Triff alle Doppel von D1 bis DBull. 9 Pfeile pro Zahl.', en: 'Hit all doubles from D1 to DBull. 9 darts per number.' },
    doppelAroundAdvancedDesc: { de: 'Triff alle Doppel von D1 bis DBull. Unbegrenzte Versuche.', en: 'Hit all doubles from D1 to DBull. Unlimited attempts.' },
    doppelAroundProDesc: { de: 'Triff alle Doppel von D1 bis DBull. 6 Pfeile pro Zahl.', en: 'Hit all doubles from D1 to DBull. 6 darts per number.' },
    doppelAroundBdcDesc: { de: 'Triff alle Doppel von D1 bis DBull. 3 Pfeile pro Zahl.', en: 'Hit all doubles from D1 to DBull. 3 darts per number.' },
    doppelSpezial: { de: 'Doppel Spezial', en: 'Double Special' },
    doppelSpezialDesc: { de: 'Sammle 10 Trefferpunkte vor 10 Fehlwürfen auf einem Doppel.', en: 'Collect 10 hit points before 10 misses on a double.' },
    tripelSpezial: { de: 'Tripel Spezial', en: 'Triple Special' },
    tripelSpezialDesc: { de: 'Sammle 10 Treffer vor 10 Fehlwürfen auf einem Triple.', en: 'Collect 10 hits before 10 misses on a triple.' },
    tripelSpezialProDesc: { de: 'Wirf 3 Pfeile pro Runde. Mindestens 1 Treffer zählt als Punkt, 3 Fehlwürfe ergeben 1 Fehlpunkt.', en: 'Throw 3 darts per round. At least 1 hit counts as a point, 3 misses result in 1 miss point.' },
    isoliertesDoppel: { de: 'Isoliertes Doppel', en: 'Isolated Double' },
    isoliertesDoppelDesc: { de: 'Wirf 3 Pfeile pro Runde. Treffer zählen als Punkte, 3 Fehlwürfe ergeben 1 Fehlpunkt.', en: 'Throw 3 darts per round. Hits count as points, 3 misses result in 1 miss point.' },
    isoliertesTriple: { de: 'Triple Isoliert', en: 'Isolated Triple' },
    isoliertesTripleDesc: { de: 'Wirf 3 Pfeile pro Runde. Treffer zählen als Punkte, 3 Fehlwürfe ergeben 1 Fehlpunkt.', en: 'Throw 3 darts per round. Hits count as points, 3 misses result in 1 miss point.' },
    doppelVariabel: { de: 'Doppel Variabel', en: 'Double Variable' },
    doppelVariabelBdcDesc: { de: 'Spiele D16, D20, D18, D12, D14, D4, DBull, D8 nacheinander. 3 Pfeile pro Runde – mindestens 1 Treffer zählt als Punkt, 3 Fehlwürfe ergeben 1 Fehlpunkt.', en: 'Play D16, D20, D18, D12, D14, D4, DBull, D8 in sequence. 3 darts per round – at least 1 hit counts as a point, 3 misses result in 1 miss point.' },
    tripleVariabel: { de: 'Triple Variabel', en: 'Triple Variable' },
    tripleVariabelBdcDesc: { de: 'Spiele T20 bis T10 nacheinander. 3 Pfeile pro Runde – mindestens 1 Treffer zählt als Punkt, 3 Fehlwürfe ergeben 1 Fehlpunkt.', en: 'Play T20 to T10 in sequence. 3 darts per round – at least 1 hit counts as a point, 3 misses result in 1 miss point.' },
    bigNumber: { de: 'Big Number', en: 'Big Number' },
    bigNumberDesc: { de: '180 oder 171 mit 3 Pfeilen. Bei Fehlwurf Neustart. 20 Versuche!', en: '180 or 171 with 3 darts. Restart on miss. 20 attempts!' },
    bigFish: { de: 'Big Fish', en: 'Big Fish' },
    bigFishDesc: { de: 'T20-T20-Bull. Bei Fehlwurf Neustart. 20 Versuche!', en: 'T20-T20-Bull. Restart on miss. 20 attempts!' },
    casino: { de: 'Casino', en: 'Casino' },
    casinoDesc: { de: 'Triff alle Felder in zufälliger Reihenfolge. Jedes Feld nur einmal!', en: 'Hit all fields in random order. Each field only once!' },
    finishMeister: { de: 'Meister des Finish', en: 'Finish Master' },
    finishMeisterDesc: { de: 'Finishes mit Countdown! Triffst du, geht\'s hoch – verfehlst du, geht\'s runter.', en: "Finishes with countdown! Hit and go up – miss and go down." },
    continuePlaying: { de: 'Weiterspielen', en: 'Continue Playing' },
    continuePlayingSub: { de: 'Setze gespeicherte Spiele fort', en: 'Resume saved games' },
    noSavedGames: { de: 'Keine gespeicherten Spiele vorhanden.', en: 'No saved games available.' },
    savedOn: { de: 'Gespeichert am', en: 'Saved on' },
    deleteSavedGame: { de: 'Löschen', en: 'Delete' },
    resumeGame: { de: 'Fortsetzen', en: 'Resume' },
  },

  // ===== TRAINING COMMON =====
  training: {
    end: { de: 'Beenden', en: 'End' },
    saveAndExit: { de: 'Speichern & Verlassen', en: 'Save & Exit' },
    restart: { de: 'Neustart', en: 'Restart' },
    back: { de: 'Zurück', en: 'Back' },
    hit: { de: 'Treffer', en: 'Hit' },
    hits: { de: 'Treffer', en: 'Hits' },
    miss: { de: 'Daneben', en: 'Miss' },
    misses: { de: 'Daneben', en: 'Misses' },
    rate: { de: 'Quote', en: 'Rate' },
    throws: { de: 'Würfe', en: 'Throws' },
    throwSingular: { de: 'Wurf', en: 'Throw' },
    progress: { de: 'Fortschritt', en: 'Progress' },
    segments: { de: 'Segmente', en: 'Segments' },
    trainingComplete: { de: 'Training abgeschlossen!', en: 'Training complete!' },
    overallHitRate: { de: 'Gesamte Trefferquote', en: 'Overall hit rate' },
    saving: { de: 'Speichern...', en: 'Saving...' },
    autoSaved: { de: '✓ Automatisch gespeichert', en: '✓ Auto-saved' },
    resultsSaved: { de: 'Ergebnisse gespeichert!', en: 'Results saved!' },
    resultSaved: { de: 'Ergebnis gespeichert!', en: 'Result saved!' },
    saveError: { de: 'Fehler beim Speichern', en: 'Error saving' },
    tryAgain: { de: 'Bitte versuche es erneut.', en: 'Please try again.' },
    couldNotSave: { de: 'Die Ergebnisse konnten nicht gespeichert werden.', en: 'Could not save results.' },
    again: { de: 'Nochmal', en: 'Again' },
    backToMenu: { de: 'Zurück zum Menü', en: 'Back to menu' },
    undoLastThrow: { de: 'Letzten Wurf rückgängig', en: 'Undo last throw' },
    undoThrow: { de: 'Wurf rückgängig machen', en: 'Undo throw' },
    segmentOverview: { de: 'Segment-Übersicht', en: 'Segment overview' },
    onlySingles: { de: 'Nur Single-Felder erlaubt', en: 'Only single fields allowed' },
    allFields: { de: 'Single, Triple und Doppel, alle Felder erlaubt', en: 'Single, triple and double, all fields allowed' },
    throwUntilHit: { de: 'Wirf bis du triffst!', en: 'Throw until you hit!' },
    firstDartOnly: { de: 'Triff mit dem 1. Pfeil!', en: 'Hit with your 1st dart!' },
    throwXOf: { de: 'Wurf', en: 'Throw' },
    of: { de: 'von', en: 'of' },
    total: { de: 'insgesamt', en: 'total' },
    remaining: { de: 'übrig', en: 'remaining' },
    target: { de: 'Ziel', en: 'Target' },
    attempt: { de: 'Versuch', en: 'Attempt' },
    attempts: { de: 'Versuche', en: 'Attempts' },
    completed: { de: 'Geschafft', en: 'Completed' },
    won: { de: 'Gewonnen!', en: 'Won!' },
    lost: { de: 'Verloren!', en: 'Lost!' },
    savingDots: { de: 'Speichere...', en: 'Saving...' },
    onlyDoubles: { de: 'Nur Doppel zählt als Treffer', en: 'Only doubles count as hits' },
    onlyTriples: { de: 'Nur Triple zählt als Treffer', en: 'Only triples count as hits' },
    collect10Hits: { de: 'Sammle 10 Treffer zum Sieg', en: 'Collect 10 hits to win' },
    tenMissLost: { de: '10× Daneben = Verloren', en: '10× Miss = Lost' },
    tenHitWin: { de: '10× Treffer = Sieg', en: '10× Hit = Win' },
    tenHits: { de: '10 Treffer!', en: '10 Hits!' },
    tenMisses: { de: '10 Daneben!', en: '10 Misses!' },
    gameProgress: { de: 'Spielverlauf', en: 'Game progress' },
    doubleOverview: { de: 'Doppel-Übersicht', en: 'Double overview' },
    tripleOverview: { de: 'Triple-Übersicht', en: 'Triple overview' },
    doubleAroundComplete: { de: 'Doppel Around abgeschlossen!', en: 'Double Around complete!' },
    tripleTrainingComplete: { de: 'Triple-Training abgeschlossen!', en: 'Triple Training complete!' },
    chooseDoubleRow: { de: 'Wähle dein Doppel und triff es so oft wie du kannst.', en: 'Choose your double and hit it as often as you can.' },
    chooseTriple: { de: 'Wähle dein Triple zum Trainieren', en: 'Choose your triple to train' },
    bullPrecision: { de: 'Bull-Präzisionstraining', en: 'Bull precision training' },
    singleTargetTraining: { de: 'Single-Treffertraining', en: 'Single target training' },
    singleTargetUnlocked: { de: 'Single-Treffertraining freigeschaltet!', en: 'Single target training unlocked!' },
    singleXComplete: { de: 'abgeschlossen!', en: 'complete!' },
    nextTo: { de: 'Weiter zu Single', en: 'Continue to Single' },
    showResults: { de: 'Ergebnisse anzeigen', en: 'Show results' },
    newRecord: { de: 'Neuer Rekord!', en: 'New record!' },
    previously: { de: 'Bisher:', en: 'Previously:' },
    ofThrows: { de: 'Würfen', en: 'throws' },
    chooseTargetHit3: { de: 'Wähle dein Ziel und triff alle 3 Pfeile!', en: 'Choose your target and hit all 3 darts!' },
    achieved: { de: 'geschafft!', en: 'achieved!' },
    notAchieved: { de: 'nicht geschafft', en: 'not achieved' },
    dart: { de: 'Pfeil', en: 'Dart' },
    dartXOf3: { de: 'von 3', en: 'of 3' },
    lastAttempts: { de: 'Letzte Versuche', en: 'Last attempts' },
    hitFor: { de: 'Triff', en: 'Hit' },
    forPoints: { de: 'für', en: 'for' },
    points: { de: 'Punkte', en: 'points' },
    currentTarget: { de: 'Aktuelles Ziel', en: 'Current target' },
    targetsRemaining: { de: 'Ziele übrig', en: 'targets remaining' },
    alreadyHit: { de: 'Bereits getroffen', en: 'Already hit' },
    casinoComplete: { de: 'Casino abgeschlossen!', en: 'Casino complete!' },
    hitNow: { de: 'Triff jetzt', en: 'Hit now' },
    singleDoubleTriple: { de: 'Single, Double oder Triple - Hauptsache', en: 'Single, double or triple - just hit' },
    throwOverview: { de: 'Wurfübersicht', en: 'Throw overview' },
    round: { de: 'Runde', en: 'Round' },
    perfektLeg: { de: 'Perfekt Leg!', en: 'Perfect Leg!' },
    missRestart: { de: 'Daneben! Neustart...', en: 'Missed! Restarting...' },
    bust: { de: 'Überworfen!', en: 'Bust!' },
    restartDots: { de: 'Neustart...', en: 'Restarting...' },
    result: { de: 'Ergebnis', en: 'Result' },
    legsFinished: { de: 'Legs beendet', en: 'Legs finished' },
    totalDarts: { de: 'Gesamt Darts', en: 'Total darts' },
    checkoutRate: { de: 'Checkout-Quote', en: 'Checkout rate' },
    checkoutHits: { de: 'Checkout-Treffer', en: 'Checkout hits' },
    legOverview: { de: 'Leg-Übersicht:', en: 'Leg overview:' },
    playAgain: { de: 'Nochmal spielen', en: 'Play again' },
    savingResults: { de: 'Speichere Ergebnisse...', en: 'Saving results...' },
    resultsSavedSuccess: { de: 'Ergebnisse gespeichert', en: 'Results saved' },
    enterThrow: { de: 'eingeben', en: 'enter' },
    tapForSingle: { de: 'Tippe eine Zahl für Single. Wähle Double/Triple für Multiplikatoren.', en: 'Tap a number for single. Choose Double/Triple for multipliers.' },
    noTriple25: { de: '25 hat kein Triple!', en: '25 has no triple!' },
    throwInOrder: { de: 'Bitte gib die Würfe der Reihe nach ein!', en: 'Please enter throws in order!' },
    overThrown: { de: 'Überworfen!', en: 'Overthrown!' },
    bustRest1: { de: 'Überworfen! Rest 1 ist nicht checkbar!', en: 'Bust! Remaining 1 is not checkable!' },
    bustDoubleOnly: { de: 'Überworfen! Finish nur mit Double möglich!', en: 'Bust! Finish only possible with double!' },
    leg: { de: 'Leg', en: 'Leg' },
    lastThrowUndo: { de: 'Letzter Wurf rückgängig', en: 'Undo last throw' },
    first9Avg: { de: 'Erster-9-AVG', en: 'First-9-AVG' },
    checkout: { de: 'Checkout', en: 'Checkout' },
    checkoutAttempts: { de: 'Checkout-Versuche', en: 'Checkout attempts' },
    roundXOfY: { de: 'Runde', en: 'Round' },
    rounds: { de: 'Runden', en: 'Rounds' },
    rest: { de: 'Rest', en: 'Remaining' },
    firstDartOn: { de: 'Erster Dart auf:', en: 'First dart at:' },
    recommendedPath: { de: 'Empfohlener Weg:', en: 'Recommended path:' },
    clickField: { de: 'Klicke auf ein Feld', en: 'Click a field' },
    previousRounds: { de: 'Bisherige Runden', en: 'Previous rounds' },
    combinedHitRate: { de: 'Kombinierte Trefferquote', en: 'Combined hit rate' },
    roundsFinished: { de: 'Runden beendet', en: 'Rounds finished' },
    bullFinishes: { de: 'Bull-Finishes', en: 'Bull finishes' },
    avgDartsRound: { de: 'Ø Darts/Runde', en: 'Avg darts/round' },
    roundOverview: { de: 'Rundenübersicht:', en: 'Round overview:' },
    restBackTo: { de: 'Rest zurück auf', en: 'Remaining back to' },
    notCheckable: { de: 'ist nicht checkbar! Rest zurück auf', en: 'is not checkable! Remaining back to' },
    autoSavedResults: { de: 'Ergebnisse automatisch gespeichert!', en: 'Results auto-saved!' },
    saveResultsError: { de: 'Fehler beim Speichern der Ergebnisse.', en: 'Error saving results.' },
    finishMaster: { de: 'Meister des Finish', en: 'Finish Master' },
    setupTraining: { de: 'Stelle dein Training ein', en: 'Set up your training' },
    startNumber: { de: 'Startzahl (2-170)', en: 'Starting number (2-170)' },
    excluded: { de: 'Ausgenommen: 169, 168, 166, 165, 163, 162, 159', en: 'Excluded: 169, 168, 166, 165, 163, 162, 159' },
    attemptsPerNumber: { de: 'Versuche pro Zahl (1-10)', en: 'Attempts per number (1-10)' },
    howOften3Darts: { de: 'Wie oft du 3 Pfeile auf eine Zahl wirfst', en: 'How many times you throw 3 darts at a number' },
    countdownMinutes: { de: 'Countdown (Minuten)', en: 'Countdown (minutes)' },
    startGame: { de: 'Spiel starten', en: 'Start game' },
    invalidStartNumber: { de: 'Ungültige Startzahl!', en: 'Invalid starting number!' },
    attemptsBetween: { de: 'Versuche müssen zwischen 1 und 10 sein!', en: 'Attempts must be between 1 and 10!' },
    timeMin1: { de: 'Zeit muss mindestens 1 Minute sein!', en: 'Time must be at least 1 minute!' },
    currentFinish: { de: 'Aktuelles Finish', en: 'Current finish' },
    highestNumber: { de: 'Höchste Zahl', en: 'Highest number' },
    hitRate: { de: 'Trefferquote', en: 'Hit rate' },
    history: { de: 'Verlauf', en: 'History' },
    timeUp: { de: 'Zeit abgelaufen!', en: "Time's up!" },
    maxReached: { de: 'Maximum erreicht!', en: 'Maximum reached!' },
    hitContinueTo: { de: 'Getroffen! Weiter zu', en: 'Hit! Continue to' },
    notAchievedBackTo: { de: 'Nicht geschafft! Zurück zu', en: 'Not achieved! Back to' },
    belowTwo: { de: 'Unter 2 gefallen!', en: 'Dropped below 2!' },
    warmUpComplete: { de: 'Aufwärmen abgeschlossen!', en: 'Warm-up complete!' },
    readyForTraining: { de: 'Du bist bereit für dein Training.', en: 'You are ready for your training.' },
    dartsThrown: { de: 'Pfeile geworfen', en: 'Darts thrown' },
    noStats: { de: 'Keine Leistungsbewertung • Nicht zur Statistik gezählt', en: 'No performance rating • Not counted in statistics' },
    noStatsSaved: { de: 'Keine Statistik gespeichert – das Aufwärmen dient nur der Aktivierung.', en: 'No statistics saved – warm-up is for activation only.' },
    warmUpRoutine: { de: 'Aufwärmroutine', en: 'Warm-up routine' },
    activateTechnique: { de: 'Aktiviere Technik & Gefühl', en: 'Activate technique & feeling' },
    totalProgress: { de: 'Gesamtfortschritt', en: 'Total progress' },
    arrows: { de: 'Pfeile', en: 'Darts' },
    phase: { de: 'Phase', en: 'Phase' },
    skipPhase: { de: 'Phase überspringen', en: 'Skip phase' },
    endWarmUp: { de: 'Aufwärmen beenden', en: 'End warm-up' },
    dartsThrown3: { de: '3 Pfeile geworfen', en: '3 darts thrown' },
    tip: { de: 'Tipp:', en: 'Tip:' },
    bullWarmUp: { de: 'Bull Aufwärmen', en: 'Bull warm-up' },
    bullWarmUpDesc: { de: 'Wirf 15 Pfeile auf das Bull. Konzentriere dich auf die Mitte.', en: 'Throw 15 darts at the bull. Focus on the center.' },
    bullWarmUpTip: { de: 'Fokussiere dich auf die Mitte des Boards und halte deine Wurfbewegung konstant.', en: 'Focus on the center of the board and keep your throwing motion consistent.' },
    singleControl: { de: 'Segmentkontrolle', en: 'Segment control' },
    singleControlDesc: { de: 'Wirf gezielt nacheinander auf die großen Single Felder (20-19-18). Finde dein Gefühl.', en: 'Throw at the big single fields (20-19-18) one after another. Find your feeling.' },
    singleControlTip: { de: 'Nimm dir Zeit beim Zielen. Atme ruhig ein und aus.', en: 'Take your time aiming. Breathe calmly in and out.' },
    aroundSingles: { de: 'Einmal Rundherum', en: 'Once around' },
    aroundSinglesDesc: { de: 'Wirf jedes Feld auf dem Dartboard.', en: 'Hit every field on the dartboard.' },
    phaseXofY: { de: 'Phase {n} von {total}', en: 'Phase {n} of {total}' },
    aroundSinglesTip: { de: 'Kein Druck – es geht nur darum, jedes Feld einmal anzuvisieren.', en: 'No pressure – just aim at each field once.' },
    doubleTraining: { de: 'Doppeltraining', en: 'Double training' },
    doubleTrainingDesc: { de: 'Wirf auf deine gewählte Doppel-Route.', en: 'Throw at your chosen double route.' },
    doubleTrainingTip: { de: 'Konzentriere dich auf eine saubere Wurfbewegung zum Doppelfeld.', en: 'Focus on a clean throwing motion towards the double field.' },
    chooseDoubleRoute: { de: 'Wähle deine bevorzugte Doppel-Route:', en: 'Choose your preferred double route:' },
    classicLeft: { de: 'Klassische linke Seite', en: 'Classic left side' },
    rightSide: { de: 'Rechte Seite', en: 'Right side' },
    throwAtRoute: { de: 'Wirf auf', en: 'Throw at' },
    currentBlock: { de: 'Aktueller Block', en: 'Current block' },
    block: { de: 'Block', en: 'Block' },
    scoreInput: { de: 'Wurf eingeben', en: 'Enter throw' },
    undo: { de: 'Rückgängig', en: 'Undo' },
    currentRound: { de: 'Aktuelle Runde', en: 'Current round' },
    darts: { de: 'Darts', en: 'Darts' },
    perDart: { de: 'Ø/Dart', en: 'Avg/Dart' },
    perRound: { de: 'Ø/Runde', en: 'Avg/Round' },
    checkoutExcl: { de: 'Checkout!', en: 'Checkout!' },
    still: { de: 'Noch', en: 'Still' },
  },

  // ===== USER MENU =====
  userMenu: {
    editProfile: { de: 'Profil bearbeiten', en: 'Edit profile' },
    statistics: { de: 'Statistiken', en: 'Statistics' },
    signOut: { de: 'Abmelden', en: 'Sign out' },
  },

  // ===== COMMON =====
  common: {
    pageNotFound: { de: 'Seite nicht gefunden', en: 'Page not found' },
    backToStart: { de: 'Zurück zur Startseite', en: 'Back to home' },
    loading: { de: 'Laden...', en: 'Loading...' },
    newPassword: { de: 'Neues Passwort', en: 'New password' },
    enterNewPassword: { de: 'Gib dein neues Passwort ein', en: 'Enter your new password' },
    confirmPassword: { de: 'Passwort bestätigen', en: 'Confirm password' },
    savePassword: { de: 'Passwort speichern', en: 'Save password' },
    passwordChanged: { de: 'Passwort geändert!', en: 'Password changed!' },
    redirecting: { de: 'Du wirst zur Anmeldung weitergeleitet...', en: 'Redirecting to login...' },
    linkExpired: { de: 'Link ungültig oder abgelaufen', en: 'Link invalid or expired' },
    linkExpiredDesc: { de: 'Der Link zum Zurücksetzen des Passworts ist ungültig oder bereits abgelaufen. Bitte fordere einen neuen Link an.', en: 'The password reset link is invalid or expired. Please request a new link.' },
    toLogin: { de: 'Zur Anmeldung', en: 'To login' },
    passwordsNotMatch: { de: 'Die Passwörter stimmen nicht überein.', en: 'Passwords do not match.' },
    passwordTooShort: { de: 'Das Passwort muss mindestens 6 Zeichen lang sein.', en: 'Password must be at least 6 characters.' },
    passwordUpdated: { de: 'Dein Passwort wurde erfolgreich aktualisiert.', en: 'Your password has been updated successfully.' },
    error: { de: 'Fehler', en: 'Error' },
  },

  // ===== WOCHENCHALLENGE =====
  wochenchallenge: {
    navTitle: { de: 'Wochenchallenge', en: 'Weekly Challenge' },
    pill: { de: 'Wochenchallenge', en: 'Weekly Challenge' },
    weekPrefix: { de: 'KW', en: 'CW' },
    epOverview: { de: 'EP-ÜBERSICHT', en: 'EP OVERVIEW' },
    epHowTo: { de: 'So bekommst du EP', en: 'How you earn EP' },
    period: { de: 'Zeitraum', en: 'Period' },
    dartsLeftTitle: { de: 'Deine Pfeile heute', en: 'Your darts today' },
    dartsLeft: { de: 'Heute noch {left} von {total} Pfeilen übrig', en: '{left} of {total} darts left today' },
    dartsLeftShort: { de: 'Heute noch {left} Pfeile übrig', en: '{left} darts left today' },
    dartsNoneShort: { de: 'Heute keine Pfeile mehr — morgen wieder {total}', en: 'No darts left today — {total} again tomorrow' },
    soonTitle: { de: 'Werfen kommt in Kürze', en: 'Throwing coming soon' },
    soonText: {
      de: 'Die Eingabe der Würfe wird in Kürze freigeschaltet. Bis dahin siehst du hier die Aufgabe der Woche und die Rangliste.',
      en: 'Throw entry will be unlocked shortly. Until then you can see this week\u2019s task and the ranking here.',
    },
    rankingTitle: { de: 'Rangliste der Woche', en: 'Weekly ranking' },
    emptyRanking: { de: 'Noch keine Würfe diese Woche', en: 'No throws this week yet' },
    noChallengeTitle: { de: 'Gerade läuft keine Challenge', en: 'No challenge running right now' },
    noChallengeText: {
      de: 'Sobald die nächste Wochenchallenge startet, findest du sie hier.',
      en: 'As soon as the next weekly challenge starts, you will find it here.',
    },
    banned: { de: 'Du bist für diese Woche gesperrt.', en: 'You are banned for this week.' },
    points: { de: 'Punkte', en: 'Points' },
    darts: { de: 'Pfeile', en: 'Darts' },
    average: { de: 'Average', en: 'Average' },
    goto: { de: 'Zur Wochenchallenge', en: 'Go to weekly challenge' },
    you: { de: '(Du)', en: '(You)' },
    progressLabel: { de: 'FORTSCHRITT', en: 'PROGRESS' },
    dartsUsed: { de: 'Pfeile genutzt', en: 'darts used' },
    rankLabel: { de: 'PLATZIERUNG', en: 'RANK' },
    rankOf: { de: 'von {count}', en: 'of {count}' },
    rankNone: { de: 'noch nicht dabei', en: 'not ranked yet' },
    heroKicker: { de: 'WOCHEN-CHALLENGE', en: 'WEEKLY CHALLENGE' },
    yourRank: { de: 'DEIN PLATZ', en: 'YOUR RANK' },
    ofPlayers: { de: 'von {count} Spielern', en: 'of {count} players' },
    weekPoints: { de: 'WOCHENPUNKTE', en: 'WEEKLY POINTS' },
    throwsToday: { de: 'WÜRFE HEUTE', en: 'THROWS TODAY' },
    remainingShort: { de: '{count} verbleibend', en: '{count} remaining' },
    endsIn: { de: 'CHALLENGE ENDET IN', en: 'CHALLENGE ENDS IN' },
    ended: { de: 'Beendet', en: 'Ended' },
    unitDays: { de: 'Tage', en: 'Days' },
    unitHours: { de: 'Std.', en: 'Hrs' },
    unitMinutes: { de: 'Min.', en: 'Min' },
    unitSeconds: { de: 'Sek.', en: 'Sec' },
    playedOf: { de: '{used} von {total} gespielt', en: '{used} of {total} played' },
    playNow: { de: 'Jetzt spielen', en: 'Play now' },
    comingSoon: { de: 'Kommt in Kürze', en: 'Coming soon' },
    todaysRound: { de: 'HEUTIGE RUNDE', en: "TODAY'S ROUND" },
    todaysGame: { de: 'HEUTIGES SPIEL', en: "TODAY'S GAME" },
    mode: { de: 'Modus: {mode}', en: 'Mode: {mode}' },
    throwsChip: { de: '{count} Würfe', en: '{count} throws' },
    throwsRemaining: { de: 'WÜRFE VERBLEIBEND', en: 'THROWS REMAINING' },
    pointsToday: { de: 'PUNKTE HEUTE', en: 'POINTS TODAY' },
    bestThrow: { de: 'BESTER WURF', en: 'BEST THROW' },
    lastThrow: { de: 'LETZTER WURF', en: 'LAST THROW' },
    ofTotal: { de: 'von {total}', en: 'of {total}' },
    yourWeek: { de: 'DEINE WOCHE', en: 'YOUR WEEK' },
    statusCompleted: { de: 'Abgeschlossen', en: 'Completed' },
    statusInProgress: { de: 'Läuft', en: 'In progress' },
    statusOpen: { de: 'Heute offen', en: 'Open today' },
    statusExpired: { de: '{count} verfallen', en: '{count} expired' },
    statusMissed: { de: 'Nicht gespielt', en: 'Not played' },
    statusUpcoming: { de: 'Noch nicht gespielt', en: 'Not played yet' },
    lastChallenge: { de: 'LETZTE CHALLENGE', en: 'LAST CHALLENGE' },
    placeOf: { de: 'Platz {rank} von {count}', en: 'Rank {rank} of {count}' },
    pointsValue: { de: '{count} Punkte', en: '{count} points' },
    dartsPlayed: { de: '{thrown} von {possible} Würfen gespielt', en: '{thrown} of {possible} darts played' },
    fullResult: { de: 'Komplettes Ergebnis ansehen', en: 'View full result' },
    liveRanking: { de: 'LIVE-RANGLISTE', en: 'LIVE RANKING' },
    rankingCardTitle: { de: 'Rangliste', en: 'Rangliste' },
    colPos: { de: 'Pos', en: 'Pos' },
    colName: { de: 'Name', en: 'Name' },
    colPoints: { de: 'Punkte', en: 'Punkte' },
    showAll: { de: 'Alle anzeigen', en: 'Show all' },
    showLess: { de: 'Weniger anzeigen', en: 'Show less' },
    player: { de: 'Spieler', en: 'Player' },

    gapToNext: { de: 'Noch {diff} Punkte bis Platz {rank}', en: '{diff} points to rank {rank}' },
    chatTitle: { de: 'Chat', en: 'Chat' },
    lockedBarNote: {
      de: 'Teil von Pro — ansehen kannst du sie trotzdem',
      en: 'Part of Pro — you can still take a look',
    },
    lockedTitle: { de: 'Mitspielen ist Teil von Pro', en: 'Playing is part of Pro' },
    lockedText: {
      de: 'Die laufende Challenge kannst du dir jederzeit ansehen. In den ersten 14 Tagen nach der Registrierung darfst du frei mitspielen.',
      en: 'You can watch the running challenge any time. In the first 14 days after signing up you can play along for free.',
    },
    lockedCta: { de: 'Pro entdecken', en: 'Discover Pro' },
    lockedChatText: {
      de: 'Mitreden können Pro-Mitglieder und alle in den ersten 14 Tagen nach der Registrierung.',
      en: 'Pro members and everyone in their first 14 days after signing up can join the conversation.',
    },


  },

  // ===== LANGUAGE =====
  language: {
    de: { de: 'Deutsch', en: 'German' },
    en: { de: 'Englisch', en: 'English' },
  },
} as const;

// Helper type for accessing translations
export type TranslationKey = keyof typeof translations;

export function t(section: keyof typeof translations, key: string, lang: Language): string {
  const sec = translations[section] as any;
  if (!sec || !sec[key]) return key;
  return sec[key][lang] || sec[key]['de'] || key;
}
